import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchManagementCompanies: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'ManagementCompany/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_MGMTCOMPANY_REQUEST,
                        types.SEARCH_MGMTCOMPANY_SUCCESS,
                        types.SEARCH_MGMTCOMPANY_FAILURE
                    ]
                }
            });
        },

    saveManagementCompany: (mgmt) =>
        (dispatch) => {
            if (mgmt.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'ManagementCompany/create',
                        method: 'POST',
                        body: mgmt,
                        types: [
                            types.CREATE_MGMTCOMPANY_REQUEST,
                            types.CREATE_MGMTCOMPANY_SUCCESS,
                            types.CREATE_MGMTCOMPANY_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'ManagementCompany/update',
                        method: 'PUT',
                        body: mgmt,
                        types: [
                            types.UPDATE_MGMTCOMPANY_REQUEST,
                            types.UPDATE_MGMTCOMPANY_SUCCESS,
                            types.UPDATE_MGMTCOMPANY_FAILURE
                        ]
                    }
                });
            }
        }
}
